import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";
import { DateFormatPipe } from "ngx-moment";
import { InterviewDataService } from '../student/interview/services/interview-data.service';
import { BackendService } from '../common/services/backend.service';
declare var window:any;

@Component({
    selector: 'mgr-reviewer-feedback',
    templateUrl: './mgr-reviewer-feedback-modal.component.html',
    standalone: false
})

export class ManagerReviewerFeedbackModalComponent {

    @Input() interview: any;
    @Input() currentReviewer: any;
    @Input() external:boolean;

    public reviewerFeedback:Array<any> = [];
    public fb: any;
    public formattedInterviewDate: any;
    public hasFeedback: any

    constructor(
        public activeModal: NgbActiveModal,
        private modalService: NgbModal,
        private dateFormatPipe: DateFormatPipe,
        private _backendService: BackendService,
        private _dataService: InterviewDataService,
        private router: Router
    ) {}

    ngOnInit() {
        let param = '/feedback';
        if (this.external) {
            param = param + '?t=' + window.parent.REVIEWER_TOKEN;
        }
        this._backendService.getAll(param, 'video-interview-attempt/' + this._dataService.attemptId).subscribe((resp) => {
            if (resp) {
                this.reviewerFeedback = resp;
                    this.reviewerFeedback.forEach((f) => {
                        if ((f.rating && f.rating !== '0') || (f.review && f.review !== '')) {
                            this.hasFeedback = true;
                        }
                    });
            }
        });
        this.formattedInterviewDate = this.dateFormatPipe.transform(this.interview.created, 'lll')
    }
}
